import { createSelector } from 'reselect';

import { Party } from 'types/service';
import { StoreType } from '@tock/shared/utils/connect';
import { partiesByIdSelector } from 'selectors/partiesById';

export const selectedPartySelector = createSelector(
  partiesByIdSelector,
  (state: StoreType) => state.service.ui.selectedPartyId,
  (partiesById, selectedPartyId?: number): Party | undefined => {
    let selectedParty = undefined;
    if (selectedPartyId) {
      selectedParty = partiesById[selectedPartyId as number];
    }
    return selectedParty;
  }
);
